import { GLOBLE_PIN, GLOBLE_PIN_ERROR, GLOBLE_PIN_HIDE_ERROR, GLOBLE_PIN_START_LOADER, GLOBLE_PIN_STOP_LOADER, } from "../interface/getGloblePin";
const initialState = {
    data: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const getGloblePin = (state = initialState, action) => {
    switch (action.type) {
        case GLOBLE_PIN:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case GLOBLE_PIN_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case GLOBLE_PIN_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case GLOBLE_PIN_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case GLOBLE_PIN_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default getGloblePin;
